// New favicon with hope800 dot in upper left corner
export const SupplyFaviconNotif320 = '9d60eefb-b641-4667-818d-5d36e68e4500'
// Old favicon with red dot in upper left corner
// export const SupplyFaviconNotif320 = '1ba0af50-7e56-498b-31fc-58117b553300'
export const SupplyFavicon320 = '238d2893-1f82-4ed7-ccc5-321d56c0ec00'
export const PatientFaviconNotif320 = '8403013a-e411-4dfa-46ed-d95f4165f900'
export const PatientFavicon320 = 'feadecdf-e692-4d94-a19c-9ab8ac4ac700'
